<template>

<!-- Dashboard Panel -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
  <DashboardCard
    label="Solicitudes Láser"
    :value="prospectosHoy"
    iconBg="bg-blue-500"
    to="/admin/prospectos"
  >
    <template #icon>
      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM5 13a6 6 0 1112 0H5z" />
      </svg>
    </template>
  </DashboardCard>

  <DashboardCard
    label="Citas del Día"
    :value="citasHoy"
    iconBg="bg-emerald-500"
    to="/admin/calendario"
  >
    <template #icon>
      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M8 7V3H6v4H3v2h18V7h-3V3h-2v4H8zM5 20c0 1.1.9 2 2 2h10a2 2 0 002-2V9H5v11z"/>
      </svg>
    </template>
  </DashboardCard>

  <DashboardCard
    label="Ventas Hoy (USD)"
    :value="ventasHoy"
    iconBg="bg-indigo-500"
    to="/pos"
  >
    <template #icon>
      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
        <path d="M11 17a1 1 0 102 0v-1.586l2.293 2.293a1 1 0 001.414-1.414l-3.707-3.707V9a1 1 0 10-2 0v4.586l-3.707-3.707a1 1 0 10-1.414 1.414L11 15.414V17z" />
      </svg>
    </template>
  </DashboardCard>

  <DashboardCard
    label="Clientes Activos"
    :value="clientesActivos"
    iconBg="bg-pink-500"
    to="/admin/crear-paciente"
  >
    <template #icon>
      <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>
    </template>
  </DashboardCard>
</div>


  <div class="wrapper">
    <!-- Navbar fija superior -->
    <nav class="bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center justify-start">
            <span class="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white ml-2">
              Nat Spa And Wellness Center
            </span>
          </div>
          <!-- Botón del menú -->
          <div class="flex items-center">
            <button
              @click="toggleDrawer"
              type="button"
              class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="drawer-navigation"
            >
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                <path clip-rule="evenodd" fill-rule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Drawer -->
    <div
      id="drawer-navigation"
      :class="{'translate-x-0': isDrawerOpen, '-translate-x-full': !isDrawerOpen}"
      class="fixed top-0 left-0 z-40 w-64 h-screen p-4 overflow-y-auto transition-transform bg-white dark:bg-gray-800"
      tabindex="-1"
      aria-labelledby="drawer-navigation-label"
    >
      <h5 id="drawer-navigation-label" class="text-base font-semibold text-gray-500 uppercase dark:text-gray-400">Menu</h5>
      <button
        type="button"
        @click="toggleDrawer"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 end-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
      >
        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
        <span class="sr-only">Cerrar menu</span>
      </button>

      <div class="py-4 overflow-y-auto">
        <ul class="space-y-2 font-medium">
          <li>
            <router-link to="/admin/banner" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-image w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Promociones</span>
            </router-link>
          </li>
          <li>
            <router-link to="/pos" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-cash-register w-5 h-5 text-gray-500"></i>
              <span class="ms-3">POS</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/crear-enfermero" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-user-nurse w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Esteticistas</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/crear-paciente" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-user-plus w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Clientes Activos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/prospectos" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-user-plus w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Prospectos</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/calendario" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-calendar-alt w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Calendario</span>
            </router-link>
          </li>
          <li>
            <router-link to="/admin/horarios" @click="toggleDrawer" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-user-clock w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Horarios Empleados</span>
            </router-link>
          </li>
          <li>
            <a @click="logout" href="#" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-sign-out-alt w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Cerrar Sesión</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Contenido principal -->
    <div class="p-4">
      <div class="p-4 border-2 border-gray-200 rounded-lg dark:border-gray-700">
        <router-view />
      </div>
    </div>

    <!-- 🎂 TARJETAS DE CUMPLEAÑOS -->
    <div v-if="cumpleaneros.length" class="fixed bottom-4 right-4 z-50 space-y-3">
      <div
        v-for="p in cumpleaneros"
        :key="p.id"
        class="bg-yellow-100 border border-yellow-400 text-yellow-900 p-4 rounded-lg shadow-md w-80"
      >
        <p class="font-bold mb-1">🎂 ¡Cumpleaños pronto!</p>
        <p class="text-sm">
          {{ p.nombre }} cumple el
          <strong>{{ obtenerFechaFormateada(p.fechaNacimiento) }}</strong>
        </p>
        <button
          @click="marcarComoFelicitado(p.id)"
          class="mt-3 text-sm px-3 py-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded"
        >
          Marcar como felicitado
        </button>
      </div>
    </div>

    <!-- 📨 TARJETAS DE SOLICITUDES -->
    <div v-if="solicitudesPendientes.length" class="fixed bottom-4 left-4 z-50 space-y-3">
      <div
        v-for="s in solicitudesPendientes"
        :key="s.id"
        class="bg-blue-100 border border-blue-400 text-blue-900 p-4 rounded-lg shadow-md w-80"
      >
        <p class="font-bold mb-1">🚨 Nueva solicitud de dosis</p>
        <div class="text-sm">
          Paciente: <strong>{{ s.nombrePaciente }}</strong> <br>
          Fecha: {{ new Date(s.fecha.toDate()).toLocaleDateString() }}
        </div>
        <button
          @click="irAFormulario(s)"
          class="mt-3 text-sm px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded"
        >
          Ver solicitud
        </button>
      </div>
    </div>

    <AppToast
  :show="showLaserToast"
  type="success"
  :clickable="true"
  to="/admin/prospectos"
  :message="`Solicitudes láser Cliente Activo (${laserPendientesCount}) — tocar para revisar`"
/>
<AppToast
  :show="showFlujo2Toast"
  type="info"
  :clickable="true"
  to="/admin/prospectos"
  :message="`Clientes nuevos con solicitud láser (${flujo2Count}) — tocar para revisar`"
/>





  </div>
</template>

<script>
import { collection, getDocs, doc, getDoc, updateDoc, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '@/firebase';
import eventBus from '@/utils/eventBus';
import AppToast from '@/components/ui/AppToast.vue';
import DashboardCard from '@/components/ui/DashboardCard.vue'

export default {
  name: 'AdminLayout',
  components: { AppToast,DashboardCard },
  data() {
    return {
      prospectosHoy: 0,
    citasHoy: 0,
    ventasHoy: 0,
    clientesActivos: 0,
      flujo2Count: 0,
     showFlujo2Toast: false,
    
      isDrawerOpen: false,
      role: localStorage.getItem("role"),
      cumpleaneros: [],
      solicitudesPendientes: [],
      laserPendientesCount: 0,
      showLaserToast: false,
      unsubLaser: null
    };
  },
  methods: {
    async obtenerCitasDelDia() {
      const hoyISO = new Date().toISOString().split('T')[0];

      const q = query(
        collection(db, "citasGlobales"),
        where("fecha", "==", hoyISO)
      );

      const snapshot = await getDocs(q);
      this.citasHoy = snapshot.size;
    },

    async obtenerDatosDashboard() {
  try {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const hoyISO = hoy.toISOString().split('T')[0]; // para strings
    const manana = new Date(hoy);
    manana.setDate(hoy.getDate() + 1);

    // 1️⃣ Prospectos Hoy (fechaRegistro como string)
    const qProspectos = query(
      collection(db, 'prospectos'),
      where('fechaRegistro', '==', hoyISO)
    );
    const snapProspectos = await getDocs(qProspectos);
    this.prospectosHoy = snapProspectos.size;

    // 2️⃣ Citas del día (fecha como string)
    const qCitas = query(
      collection(db, 'citasGlobales'),
      where('fecha', '==', hoyISO)
    );
    const snapCitas = await getDocs(qCitas);
    this.citasHoy = snapCitas.size;

    // 3️⃣ Ventas del día (fecha como Timestamp)
    const qVentas = query(
      collection(db, 'ventas'),
      where('fecha', '>=', Timestamp.fromDate(hoy)),
      where('fecha', '<', Timestamp.fromDate(manana))
    );
    const snapVentas = await getDocs(qVentas);
    let totalVentas = 0;
    snapVentas.forEach((doc) => {
      const data = doc.data();
      const subtotal = Number(data.subtotal || 0);
      let impuestos = Number(data.impuestos || 0);
      if (impuestos > subtotal) impuestos = 0;
      totalVentas += subtotal + impuestos;
    });
    this.ventasHoy = totalVentas.toFixed(2);

    // 4️⃣ Clientes activos
    const qClientes = query(
      collection(db, 'pacientes'),
      where('activo', '==', true)
    );
    const snapClientes = await getDocs(qClientes);
    this.clientesActivos = snapClientes.size;

    console.log("✅ Dashboard actualizado");
  } catch (err) {
    console.error("❌ Error al obtener datos del dashboard:", err);
  }
},

    refrescarSolicitudesLaser() {
    console.log("🔁 Evento recibido: solicitudesLaserActualizadas");
    this.iniciarListenerSolicitudesLaser(); // vuelve a suscribirse y actualiza el count
  },
  iniciarListenerFlujo2() {
  if (this._unsubFlujo2) {
    try {
      this._unsubFlujo2();
    } catch (e) {
      console.warn("⚠️ Error cerrando listener flujo 2:", e);
    }
    this._unsubFlujo2 = null;
  }

  const qRef = query(
    collection(db, "prospectos"),
    where("servicio", "==", "depilacion_laser"),
    where("activo", "==", false) // solo pendientes
  );

  this._unsubFlujo2 = onSnapshot(
    qRef,
    (snap) => {
      const documentos = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      console.log("👥 Prospectos con láser pendientes (flujo 2):", documentos);

      this.flujo2Count = documentos.length;
      this.showFlujo2Toast = this.flujo2Count > 0;
    },
    (error) => {
      console.error("❌ Error en listener flujo 2:", error);
      this.flujo2Count = 0;
      this.showFlujo2Toast = false;
    }
  );
},


  iniciarListenerSolicitudesLaser() {
  // 🔌 Cierra el listener anterior si existe
  if (this._unsubLaser) {
    try {
      this._unsubLaser();
      console.log("🔌 Listener anterior cerrado.");
    } catch (e) {
      console.warn("⚠️ Error cerrando listener anterior", e);
    }
    this._unsubLaser = null;
  }

  const qRef = query(
    collection(db, 'solicitudesLaser'),
    where('estado', '==', 'pendiente')
  );

  // Listener en tiempo real
  this._unsubLaser = onSnapshot(
    qRef,
    (snap) => {
      const documentos = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      console.log(" Escuchando solicitudes pendientes:", documentos);

      this.laserPendientesCount = documentos.length;
      this.showLaserToast = this.laserPendientesCount > 0;
    },
    (error) => {
      console.error("❌ Error en listener solicitudesLaser:", error);
      this.laserPendientesCount = 0;
      this.showLaserToast = false;
    }
  );
},

    irAprobacionesLaser() {
      // AJUSTA a la ruta que apunte a tu PacientesProspectos.vue
      // si tienes name:
      this.$router.push({ name: 'PacientesProspectos' });
      // o si usas path:
      // this.$router.push('/admin/pacientes-prospectos');
    },

    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    logout() {
      localStorage.removeItem('authToken');
      this.$router.push('/login');
    },
    obtenerFechaFormateada(fecha) {
      if (!fecha) return '';
      try {
        const f = fecha.toDate ? fecha.toDate() : new Date(fecha);
        return f.toLocaleDateString();
      } catch (e) {
        return '';
      }
    },


    async obtenerCumpleaneros() {
  try {
    const snapshot = await getDocs(collection(db, 'pacientes'));
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0); // quitar horas
    const hoyYear = hoy.getFullYear();

    const en15dias = new Date(hoy);
    en15dias.setDate(hoy.getDate() + 15);
    en15dias.setHours(0, 0, 0, 0);

    this.cumpleaneros = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => {
        if (!p.fechaNacimiento || p.felicitadoEsteAno) return false;

        let cumple;
        if (typeof p.fechaNacimiento === 'string') {
          const [, month, day] = p.fechaNacimiento.split('-').map(Number);
          if (!month || !day) return false;
          cumple = new Date(hoyYear, month - 1, day);
        } else if (p.fechaNacimiento.toDate) {
          const fecha = p.fechaNacimiento.toDate();
          cumple = new Date(hoyYear, fecha.getMonth(), fecha.getDate());
        } else {
          return false;
        }

        cumple.setHours(0, 0, 0, 0); // quitar horas

        console.log('🎉 Evaluando:', p.nombre, '->', cumple.toDateString());
        return cumple >= hoy && cumple <= en15dias;
      });

    console.log('✅ Cumpleañeros encontrados:', this.cumpleaneros);
  } catch (err) {
    console.error('❌ Error al cargar cumpleañeros:', err);
  }
},


    async marcarComoFelicitado(pacienteId) {
      await updateDoc(doc(db, 'pacientes', pacienteId), {
        felicitadoEsteAno: true
      });
      this.cumpleaneros = this.cumpleaneros.filter(p => p.id !== pacienteId);
    },

    async obtenerSolicitudesPendientes() {
  try {
    const q = query(
      collection(db, 'solicitudesDosisGlobales'),
      where('estado', '==', 'pendiente')
    );
    const snapshot = await getDocs(q);

    const solicitudes = [];

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      const pacienteRef = doc(db, 'pacientes', data.pacienteId);
      const pacienteSnap = await getDoc(pacienteRef);

      const nombrePaciente = pacienteSnap.exists() ? pacienteSnap.data().nombre : 'Desconocido';

      solicitudes.push({
        id: docSnap.id,
        ...data,
        nombrePaciente
      });
    }

    this.solicitudesPendientes = solicitudes;
    console.log('📥 Solicitudes con nombre:', solicitudes);
  } catch (error) {
    console.error('❌ Error al obtener solicitudes:', error);
  }
},



    async marcarSolicitudComoRevisada(id) {
      await updateDoc(doc(db, 'solicitudesDosisGlobales', id), {
        revisado: true
      });
      this.solicitudesPendientes = this.solicitudesPendientes.filter(s => s.id !== id);
    },

    

async irAFormulario(solicitud) {
  try {
    const pacienteRef = doc(db, 'pacientes', solicitud.pacienteId);
    const pacienteSnap = await getDoc(pacienteRef);

    if (!pacienteSnap.exists()) {
      console.warn('⚠️ Paciente no encontrado.');
      return;
    }

    const paciente = { id: pacienteSnap.id, ...pacienteSnap.data() };

    // Emitir el evento para abrir el modal
    eventBus.emit('abrirModalDesdeSolicitud', {
      paciente,
      pestana: 'solicitudes'
    });

    // 🔻 Eliminar esta tarjeta de la lista visual
    this.solicitudesPendientes = this.solicitudesPendientes.filter(s => s.id !== solicitud.id);

  } catch (err) {
    console.error('❌ Error cargando paciente para modal:', err);
  }
},

    // otros métodos como marcarSolicitudComoRevisada, etc.
  },

  async mounted() {
  await this.obtenerCumpleaneros();
  await this.obtenerSolicitudesPendientes();
  this.iniciarListenerSolicitudesLaser();
  this.iniciarListenerFlujo2();
  await this.obtenerDatosDashboard();
  await this.obtenerCitasDelDia();


  // 🔁 ESCUCHAR evento global cuando se aprueba desde otro componente
  eventBus.on('solicitudesLaserActualizadas', this.refrescarSolicitudesLaser);
},

beforeUnmount() {
  if (this._unsubLaser) {
    try {
      this._unsubLaser();
      console.log("🔌 Listener de solicitudesLaser cerrado");
    } catch (e) {
      console.warn("⚠️ Error cerrando listener de solicitudesLaser", e);
    }
    this._unsubLaser = null;
  }

  // 🧹 Limpiar eventBus
  eventBus.off('solicitudesLaserActualizadas', this.refrescarSolicitudesLaser);
  eventBus.off("flujo2Actualizado");
},
};
</script>

<style scoped>
/* Puedes eliminar los estilos que ya no son necesarios ya que estamos usando clases de Tailwind */
</style>
